import { camelCase, transform } from "lodash-es"

type SnakeToCamel<S extends string> = S extends `${infer Head}_${infer Tail}`
  ? `${Head}${Capitalize<SnakeToCamel<Tail>>}`
  : S

type CamelCasedKeysDeep<T> = T extends readonly (infer U)[]
  ? CamelCasedKeysDeep<U>[]
  : T extends object
    ? {
        [K in keyof T as K extends string
          ? SnakeToCamel<K>
          : K]: CamelCasedKeysDeep<T[K]>
      }
    : T

export const snakeCaseToCamelCase = <T>(input: T): CamelCasedKeysDeep<T> => {
  if (Array.isArray(input)) {
    return input.map((item: unknown) =>
      snakeCaseToCamelCase(item)
    ) as CamelCasedKeysDeep<T>
  }

  if (typeof input === "object" && input !== null) {
    return transform(
      input as Record<string, unknown>,
      (result: Record<string, unknown>, value: unknown, key: string) => {
        result[camelCase(key)] = snakeCaseToCamelCase(value)
      },
      {} as Record<string, unknown>
    ) as CamelCasedKeysDeep<T>
  }

  return input as CamelCasedKeysDeep<T>
}
